import { translateUi } from "@/shared/lib/ui-translate";
/**
 * Процесс получения стрима по пользователю Twitch
 */

import { TwitchAPI, TwitchStream } from "../../api/twitch-api";

import { StreamData } from "./fetch-streams";

export interface FetchStreamByUserParams {
  userLogin: string;
}

export interface FetchStreamByUserResult {
  status: "ok" | "invalid" | "not_found" | "error";
  stream?: StreamData;
  error?: string;
}

// Функция конвертации TwitchStream в StreamData
function convertTwitchStreamToStreamData(
  twitchStream: TwitchStream,
): StreamData {
  return {
    id: twitchStream.id,
    title: twitchStream.title,
    streamer: twitchStream.user_name,
    streamerAvatar: `https://static-cdn.jtvnw.net/jtv_user_pictures/${twitchStream.user_id}-profile_image-70x70.png`,
    thumbnail: twitchStream.thumbnail_url,
    url: `https://www.twitch.tv/${twitchStream.user_login}`,
    viewers: twitchStream.viewer_count,
    duration: "LIVE",
    startTime: twitchStream.started_at,
    platform: "twitch",
    isLive: twitchStream.type === "live",
  };
}

export async function fetchTwitchStreamByUser({
  userLogin,
}: FetchStreamByUserParams): Promise<FetchStreamByUserResult> {
  try {
    // Валидация параметров
    if (
      !userLogin ||
      typeof userLogin !== "string" ||
      userLogin.trim() === ""
    ) {
      return {
        status: "invalid",
      };
    }

    // Получаем данные от Twitch API
    const twitchStream = await TwitchAPI.getStreamByUser(userLogin.trim());

    if (!twitchStream) {
      return {
        status: "not_found",
      };
    }

    // Конвертируем в наш формат
    const stream = convertTwitchStreamToStreamData(twitchStream);

    return {
      status: "ok",
      stream,
    };
  } catch (error) {
    return {
      status: "error",
      error: error instanceof Error ? error.message : translateUi("litUseTwitch.oshibkaTwitchApi"),
    };
  }
}
